import React, { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import { CustomGeneralBiomarkerModal } from '../Modals/BiomarkerModal/CustomGeneralBiomarkerModal';
import { Loading } from '../Modals/GenericModals/Loading';
import { useCustomBiomarkers } from '../CustomHooks/useCustomBiomarkers';
import { set } from 'date-fns';
import { FormatDate, OfficialFormatDateWithYear } from '../../utilities/FormatDate';
import { saveAs } from 'file-saver';

export const CustomBiomarkerButton = ({
    selectedFeedings,
    patient
}) => {

    const [biomarkerOptions, setBiomarkerOptions] = useState({
        startPoint: 'sucks-within', // 'sucks-within', 'first-suck', 'specific-time', 'first-breath', 'first-swallow'
        startSucks: '4',
        startTime: { mm: '0', ss: '0' },
        endPoint: 'duration', // 'duration', 'specific-time', 'last-suck'
        endTime: { mm: '2', ss: '0' },
    });

    const [showModal, setShowModal] = useState(false);

    const [loading, setLoading] = useState(false);

    const { biomarkers, generateBiomarkers } = useCustomBiomarkers(selectedFeedings, patient.patient_id, biomarkerOptions);


    const handleClick = () => {
        // Handle button click event
        setShowModal(!showModal);
    };

    useEffect(() => {
        if (loading) {
            // calculate biomarkers
            generateBiomarkers();
        }
    }, [loading]);

    useEffect(() => {
        ////console.log(biomarkers);
        // Exporting data to CSV file
        if (biomarkers.length > 0)
            downloadCSV();
        setLoading(false);
    }, [biomarkers]);

    const downloadCSV = () => {
        // Implement CSV download logic here
        const csvString = convertBiomarkersToString(biomarkers);

        // Create a Blob from the CSV string
        const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });

        let fileName = `${patient.ehr_patient_ref}_`;
        fileName += `${OfficialFormatDateWithYear(Date.now()).replace("/", "-").replace(":", "-")}.csv`

        saveAs(blob, fileName);
    }

    const convertBiomarkersToString = (biomarkers) => {
        ////console.log(patient)
        if (biomarkers) {
            // Convert the data array into a CSV string
            let csvString = `Patient Id, ${patient.ehr_patient_ref}\n`;
            csvString += `Patient Name, ${patient.name}\n`;
            csvString += `Internal ID, ${patient.patient_id}\n\n`;

            // Header with all params
            if (biomarkers.length > 0) {
                // Header row estracting keys from the first biomarker object
                csvString += biomarkers[0].map(obj => Object.keys(obj)[0]).join(",").replaceAll("-", " ") + "\n";

                // Biomarkers values
                biomarkers.forEach(row => {
                    // Extract the value from each object in the row
                    const values = row.map(obj => Object.values(obj)[0]);
                    // Format the first value (timestamp)
                    values[0] = FormatDate(values[0]);
                    csvString += values.join(",") + "\n";
                });
            }


            return csvString;
        }
        else {
            return "";
        }
    };

    return (
        <>
            <Button className={`neo_qv_btn w-250`} onClick={handleClick}>

                <div className="neo_header_center">

                    {
                        <span className="sr-only">Custom Biomarkers</span>
                    }
                </div>

            </Button>

            <CustomGeneralBiomarkerModal
                showModal={showModal}
                setShowModal={setShowModal}
                selectedFeedings={selectedFeedings}
                biomarkerOptions={biomarkerOptions}
                setBiomarkerOptions={setBiomarkerOptions}
                setLoading={setLoading} />

            {loading && <Loading isLoading={loading} />}
        </>
    )
}
